<!-- 用户中心 -->
<template>
  <div id="user">
    <div class="user">
      <div class="header">用户中心</div>
      <div class="body">
        <div class="user-information">
          <div style="display:flex;position: relative;height: 296px;">
            <div class="information">
              <div class="img">
                <template v-if="info.fheadPortraitPath">
                  <img :src="info.fheadPortraitPath" alt>
                </template>
                <template v-else>
                  <img src="@/assets/images/avatar.png" alt>
                </template>
                <br>
                <el-button
                  v-if="rols('修改资料')"
                  type="text"
                  style=" color:#000"
                  icon="el-icon-edit"
                  @click="edituser"
                >修改资料</el-button>
                <br>
                <!-- <el-button slot="reference" type="text" style=" color:#000" icon="el-icon-lock">修改密码</el-button> -->
                <el-popover
                  v-model="editVisible"
                  placement="bottom"
                  width="312"
                  trigger="manual"
                  popper-class="editPassword"
                  @hide="closeEdit"
                >
                  <div v-loading="editLoading">
                    <div class="edit-title">
                      修改密码
                    </div>
                    <div class="edit-content">
                      <el-form
                        ref="password"
                        size="small"
                        :model="passwordForm"
                        :rules="passwordules"
                        label-width="100px"
                        class="demo-ruleForm"
                      >
                        <el-form-item label="设置新密码:" prop="newPassword">
                          <el-input v-model="passwordForm.newPassword" type="password" />
                        </el-form-item>
                        <el-form-item label="确认新密码:" prop="cfmPassword">
                          <el-input v-model="passwordForm.cfmPassword" type="password" />
                        </el-form-item>
                      </el-form>
                    </div>
                    <div class="edit-footer">
                      <el-button size="small" class="edit-close" @click="closeEdit">取消</el-button>
                      <el-button size="small" class="edit-cfm" @click="editPassword">确定
                      </el-button>
                    </div>
                  </div>
                  <span slot="reference" class="editBtn">
                    <el-button
                      type="text"
                      style=" color:#000"
                      icon="el-icon-lock"
                      @click="editVisible = !editVisible"
                    >
                      修改密码
                    </el-button>
                  </span>
                </el-popover>

              </div>
              <div class="content">
                <div class="name">{{ info.fNickName }}</div>
                <div class="introduce">
                  <div>所属企业：{{ info.fDemandUnitName }}</div>
                  <!-- <el-divider direction="vertical" /> -->
                  <div class="member">
                    <div>会员等级：</div>
                    <div class="dj-icon">
                      <img class="hy-icon" src="img/huangjin.png" alt>
                    </div>
                    <div>黄金会员</div>
                  </div>
                </div>
              </div>
            </div>
            <div class="purchase-data">
              <div class="title">
                采购数据汇总
              </div>
              <div class="search-condition">
                <div style="width:65%;">
                  <el-date-picker
                    v-model="formData.orderData"
                    style="width:45%;"
                    value-format="yyyy-MM-dd"
                    type="daterange"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    @change="clearFormData(1)"
                  />
                  <el-input v-model="formData.FDepartNames" clearable @clear="clearDepart">
                    <i slot="suffix" class="el-icon-menu" @click="selectDeparment(true)" />
                  </el-input>
                </div>
                <el-radio-group v-model="formData.FQueryDimension" @change="clearFormData(2)">
                  <el-radio-button label="1">本周</el-radio-button>
                  <el-radio-button label="2">本月</el-radio-button>
                  <el-radio-button label="3">本季</el-radio-button>
                  <el-radio-button label="4">本年</el-radio-button>
                </el-radio-group>
              </div>
              <div class="over-box">
                <div class="show-money">
                  <div v-for="(t, i) in showBox" :key="i" class="show-box">
                    <svg-icon class="rt-svg" :icon-class="t.svg1" />
                    <svg-icon class="bg-svg" :icon-class="t.svg2" />
                    <div class="show-title">
                      {{ t.title }}
                      <el-popover
                        v-if="i == 0"
                        placement="top"
                        width="230"
                        trigger="click"
                        content="订单金额=成交金额+退货金额"
                      >
                        <i
                          slot="reference"
                          style="color:#ec212d;font-size: 18px;margin-left: 5px;"
                          class="el-icon-warning-outline"
                        />
                      </el-popover>
                    </div>
                    <div class="money-content">
                      ￥{{ t.money }}
                    </div>
                    <div class="number-conetnt">
                      <div>
                        订单数量：<span class="show-number">{{ t.FOrderCount }}</span>
                      </div>
                      <div>
                        商品数量：<span class="show-number">{{ t.FQuanty }}</span>
                      </div>
                    </div>
                    <!-- <div v-if="i === 3" class="number-conetnt">
                      售后商品数量：<span class="show-number">{{ t.FReturnQuanty }}</span>
                    </div> -->
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-if="rols('钱包')" class="wallet">
            <svg-icon icon-class="red-wallet" />
            <span class="text">钱包</span>
          </div>
        </div>
        <el-divider />
        <div v-if="rols('钱包')" class="user-wallet">
          <div class="wallet">
            <div style="color: rgb(236, 33, 45);" class="text">{{ info.availableAmount | moneyFilter }}
            </div>
            <div style="color: rgb(236, 33, 45);" class="content">可用额度</div>
          </div>
          <!-- <div class="wallet">
            <div class="text">{{ info.mallBalance | moneyFilter }}</div>
            <div class="content">商城往来金额</div>
          </div>
          <div class="wallet">
            <div class="text">{{ info.rechargeBonus | moneyFilter }}</div>
            <div class="content">充值奖励金</div>
            <div id="cursor" class="content" @click="dilongShow"><img style="width:20px;height:20px;vertical-align: sub;" src="../../../assets/images/toSee.png" alt="">查看明细</div>
          </div> -->
          <div class="wallet">
            <div class="text">
              {{ info.accountPeriod | monthFilter }}
              <el-popover placement="top" width="200" trigger="hover">
                <div>
                  结账日：{{ info.fSettleAccountsDay | changeNumToHan }}
                </div>
                <div>
                  对账日：{{ info.fReconciliationDay | changeNumToHan }}
                </div>
                <div>
                  开票日：{{ info.fBillingDay | changeNumToHan }}
                </div>
                <div>
                  付款日：{{ info.fPaymentDay | changeNumToHan }}
                </div>
                <i slot="reference" style="color:#ec212d;" class="el-icon-warning-outline" />
              </el-popover>
            </div>
            <div class="content">账期</div>
          </div>
          <div class="wallet">
            <div class="text">￥{{ (info.mallBalance * -1) | moneyFilter }}</div>
            <div class="content">当前待还款金额</div>
          </div>
        </div>
        <el-divider />
        <div class="user-record">
          <el-tabs v-model="tabsName">
            <el-tab-pane name="7">
              <span slot="label">
                <svg-icon :icon-class="tabsName == 7 ? 'all-s' : 'all'" />
                全部账单
              </span>
              <child7 v-if="tabsName == 7" />
            </el-tab-pane>
            <el-tab-pane name="3">
              <span slot="label">
                <svg-icon :icon-class="tabsName == 3 ? 'weichu-s' : 'weichu'" />
                未出账单
              </span>
              <child4 v-if="tabsName == 3" />
            </el-tab-pane>
            <el-tab-pane name="4">
              <span slot="label">
                <svg-icon :icon-class="tabsName == 4 ? 'yichu-s' : 'yichu'" />
                已出账单
              </span>
              <child5 v-if="tabsName == 4" />
            </el-tab-pane>
            <!-- <el-tab-pane name="5">
              <span slot="label">
                <svg-icon :icon-class="tabsName==5?'fukuan-s':'fukuan'" />
                付款明细
              </span>
              <child6 v-if="tabsName == 5" />
            </el-tab-pane> -->
            <el-tab-pane name="0">
              <span slot="label">
                <svg-icon :icon-class="tabsName == 0 ? 'shoucang-s' : 'shoucang'" />
                商品收藏（{{ StockCollectTotal }}）
              </span>
              <child1
                :model.sync="StockCollect.jsonobj"
                :list.sync="StockCollect.list"
                @shop-up="ShoppingCart"
                @up-date="StockCollectSear"
              />
              <el-pagination
                style="text-align: center;"
                background
                layout="total, prev, pager, next"
                :current-page.sync="StockCollect.pageNo"
                :page-size.sync="StockCollect.pageSize"
                :total="StockCollect.total"
                @current-change="StockCollectSear"
              />
            </el-tab-pane>
            <!-- <el-tab-pane name="1">
              <span slot="label">
                <svg-icon :icon-class="tabsName==1?'guanzhu-s':'guanzhu'" />
                店铺关注（{{ StoreCollectTotal }}）
              </span>
              <child2 :list.sync="StoreCollect.list" @up-date="StoreCollectSear" />
              <el-pagination
                style="text-align: center;"
                background
                layout="total, prev, pager, next"
                :current-page.sync="StoreCollect.pageNo"
                :page-size.sync="StoreCollect.pageSize"
                :total="StoreCollect.total"
                @current-change="StoreCollectSear"
              />
            </el-tab-pane> -->
            <el-tab-pane name="2">
              <span slot="label">
                <svg-icon :icon-class="tabsName == 2 ? 'jilu-s' : 'jilu'" />
                浏览记录（{{ BrowseRecordsTotal }}）
              </span>
              <child3
                ref="child3"
                :model.sync="BrowseRecords.jsonobj"
                :prop-num="BrowseRecordsNum"
                :prop-max-num="BrowseRecordsMaxNum"
                :end-sub="endSub"
                :list.sync="BrowseRecords.list"
                :select.sync="BrowseRecords.select"
                @shop-up="ShoppingCart"
                @up-date="BrowseRecordsSear"
                @info-init="initUser"
              />
            </el-tab-pane>
          </el-tabs>
        </div>
      </div>
    </div>
    <detailed ref="detailed" />
    <edit-user ref="editUser" />
    <tree
      ref="depart"
      title="所属部门"
      label="FName"
      parent-id="FParentID"
      :tree-visible="searchVisible"
      :default-arr="defaultArr"
      search-url="/mall/mallmanage/billapprovalinfo/getDepartInfo"
      @treeConfirm="cfmSearch"
      @treeClose="selectDeparment"
    />
  </div>
</template>

<script>
import request from '@/utils/request'
import child1 from './children/child1.vue'
// import child2 from './children/child2.vue'
import child3 from './children/child3.vue'
import child4 from './children/child4.vue'
import child5 from './children/child5.vue'
import child6 from './children/child6.vue'
import child7 from './children/child7.vue'
import detailed from './children/detailed.vue'
import editUser from './children/editUser.vue'
import quest from '../api/user'
import tree from '@/components/tree/tree.vue'
export default {
  components: {
    child1,
    child3,
    child4,
    child5,
    child6,
    child7,
    detailed,
    editUser,
    tree
  },
  filters: {
    // 数字转汉字
    changeNumToHan(num) {
      if (num === '') return ''
      var arr1 = ['零', '一', '二', '三', '四', '五', '六', '七', '八', '九']
      var arr2 = ['', '十', '百', '千', '万', '十', '百', '千', '亿', '十', '百', '千', '万', '十', '百', '千', '亿']
      if (!num || isNaN(num)) return '零'
      var english = num.toString().split('')
      var result = ''
      for (var i = 0; i < english.length; i++) {
        var des_i = english.length - 1 - i // 倒序排列设值
        result = arr2[i] + result
        var arr1_index = english[des_i]
        result = arr1[arr1_index] + result
      }
      result = result.replace(/零(千|百|十)/g, '零').replace(/十零/g, '十') // 将【零千、零百】换成【零】 【十零】换成【十】
      result = result.replace(/零+/g, '零') // 合并中间多个零为一个零
      result = result.replace(/零亿/g, '亿').replace(/零万/g, '万') // 将【零亿】换成【亿】【零万】换成【万】
      result = result.replace(/亿万/g, '亿') // 将【亿万】换成【亿】
      result = result.replace(/零+$/, '') // 移除末尾的零
      // 将【一十】换成【十】
      result = result.replace(/^一十/g, '十')
      return `每月${result}号`
    },
    // 金额字符处理
    moneyFilter(val) {
      if (!isNaN(Number(val))) {
        const num = Number(val).toFixed(3)
        const index = num.indexOf('.')
        const str = num.slice(index, index + 3)
        const dnum = num.slice(0, index)
        let length = dnum.length
        let lengthnum = 0
        let newstr = ''
        do {
          let dou = ''
          if (lengthnum % 3 == 0) {
            dou = ','
          }
          length--
          lengthnum++
          newstr += dou + dnum[length]
        } while (length)
        if (newstr[0] === ',') {
          newstr = newstr.slice(1)
        }
        let mony = newstr
          .split('')
          .reverse()
          .join('') + str
        if (mony.indexOf('-,') > -1) {
          mony = mony.replace(',', '')
        }
        return (
          mony
        )
      }
    },
    // 金额月份处理
    monthFilter(num) {
      if (!isNaN(Number(num))) {
        num = Math.ceil(Number(num) / 30)
        var arr1 = ['零', '一', '二', '三', '四', '五', '六', '七', '八', '九']
        var arr2 = [
          '',
          '十',
          '百',
          '千',
          '万',
          '十',
          '百',
          '千',
          '亿',
          '十',
          '百',
          '千',
          '万',
          '十',
          '百',
          '千',
          '亿'
        ]
        if (!num || isNaN(num)) return '零'
        var english = num.toString().split('')
        var result = ''
        for (var i = 0; i < english.length; i++) {
          var des_i = english.length - 1 - i
          // 倒序排列设值
          result = arr2[i] + result
          var arr1_index = english[des_i]
          result = arr1[arr1_index] + result
        }
        result = result.replace(/零(千|百|十)/g, '零').replace(/十零/g, '十')
        // 将【零千、零百】换成【零】 【十零】换成【十】
        result = result.replace(/零+/g, '零')
        // 合并中间多个零为一个零
        result = result.replace(/零亿/g, '亿').replace(/零万/g, '万')
        // 将【零亿】换成【亿】【零万】换成【万】
        result = result.replace(/亿万/g, '亿')
        // 将【亿万】换成【亿】
        result = result.replace(/零+$/, '')
        // 移除末尾的零 // 将【一十】换成【十】
        result = result.replace(/^一十/g, '十')
        return result + '个月'
      }
    }
  },

  data() {
    const validatePass = (rule, value, callback) => {
      let valid = true
      if (value === '') {
        valid = false
        callback(new Error('请输入密码'))
      }
      if (value.length < 8 || value.length > 16) {
        valid = false
        callback(new Error('密码长度为8-16位'))
      }
      if (value.length > 8 || value.length < 16) {
        const reg = /^(?![0-9]+$)(?![a-z]+$)(?![A-Z]+$)(?!([^(0-9a-zA-Z)])+$)^.{8,16}$/
        if (!reg.test(value)) {
          valid = false
          callback(new Error('密码至少包含字母/数字/ 字符两种组合'))
        }
      }
      if (valid) {
        if (this.passwordForm.passwordules !== '') {
          this.$refs.password.validateField('checkPass')
        }
        callback()
      }
    }
    var validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'))
      } else if (value !== this.passwordForm.newPassword) {
        callback(new Error('两次输入密码不一致!'))
      } else {
        callback()
      }
    }
    return {
      editVisible: false,
      editLoading: false,
      passwordForm: {
        newPassword: '',
        cfmPassword: ''
      },
      passwordules: {
        newPassword: [{
          required: true,
          validator: validatePass,
          trigger: 'blur'
        }],
        cfmPassword: [{
          required: true,
          validator: validatePass2,
          trigger: 'blur'
        }]
      },
      searchVisible: false,
      formData: {
        orderData: [],
        FBeginOrderDate: '',
        FEndOrderDate: '',
        FQueryDimension: '1',
        FTreeCode: '',
        FDepartNames: ''
      },
      showBox: [{
        title: '订单金额',
        svg1: 'user-rt1',
        svg2: 'user-bg1',
        money: '',
        FOrderCount: '',
        FQuanty: ''
      },
      {
        title: '成交金额：',
        svg1: 'user-rt2',
        svg2: 'user-bg2',
        money: '',
        FOrderCount: '',
        FQuanty: ''
      },
      // {
      //   title: '平均商品单价：',
      //   svg1: 'user-rt3',
      //   svg2: 'user-bg3',
      //   money: ''
      // },
      {
        title: '退货金额：',
        svg1: 'user-rt4',
        svg2: 'user-bg4',
        money: '',
        FOrderCount: '',
        FQuanty: ''
      }
      ],
      tabPosition: '',
      tabsName: '7',
      userInfo: {},
      info: {
        availableFund: 0,
        totalCredit: 0,
        accountPeriod: 0,
        cashBalance: 0,
        cashCoupon: 0,
        stockCollect: 0,
        storeCollect: 0,
        browseRecords: 0,
        fSettleAccountsDay: '',
        fReconciliationDay: '',
        fBillingDay: '',
        fPaymentDay: ''
      },
      StockCollectTotal: 0,
      StoreCollectTotal: 0,
      BrowseRecordsTotal: 0,
      StockCollect: {
        pageNo: 1,
        pageSize: 30,
        total: 0,
        jsonobj: {},
        list: []
      }, // 查询商品收藏分页
      StoreCollect: {
        pageNo: 1,
        pageSize: 30,
        total: 0,
        type: 0,
        jsonobj: {},
        list: []
      }, // 关注店铺分页
      BrowseRecords: {
        pageNo: 1,
        pageSize: 30,
        total: 0,
        jsonobj: {},
        list: [],
        select: []
      }, // 浏览记录分页
      defaultArr: [],
      BrowseRecordsNum: 0,
      BrowseRecordsMaxNum: 0,
      endSub: -1
    }
  },
  computed: {
    // 当前页操作权限
    rols() {
      const setting = this.$store.getters.pageSetting('用户中心')
      return function(val) {
        if (typeof setting === 'boolean') return true
        return setting.indexOf(val) > -1
      }
    }
  },
  created() {
    if (this.$route.query.mode) {
      this.tabsName = this.$route.query.mode
    }
  },
  mounted() {
    const user = localStorage.getItem('userInfo')
    if (user) {
      this.userInfo = JSON.parse(user)
    }
    this.initUser()
    this.save()
    this.getDataSummary()
    const domWidth = document.getElementById('user').offsetWidth / 216
    const domHeight = window.innerHeight / 350
    this.BrowseRecordsMaxNum = Math.ceil(domWidth) * Math.ceil(domHeight + 1) // 每屏最大数量
  },
  methods: {
    closeEdit() {
      this.passwordForm = {
        newPassword: '',
        cfmPassword: ''
      }
      this.$refs.password.clearValidate()
      this.editVisible = false
    },
    editPassword() {
      this.editLoading = true
      const userInfo = JSON.parse(localStorage.getItem('userInfo'))
      const fUserID = userInfo.fuserId
      const fPhone = userInfo.fuserPhone
      this.$refs.password.validate(valid => {
        if (valid) {
          const jsonStr = {
            fUserID,
            fPhone,
            fPassword: this.passwordForm.cfmPassword
          }
          const data = new URLSearchParams()
          data.append('jsonStr', JSON.stringify(jsonStr))
          request({
            url: '/mall/updateDemandUserPassword',
            method: 'post',
            data
          })
            .then(res => {
              if (res.result) {
                this.$message.success(res.msg)
                this.closeEdit()
              } else {
                this.$message.error(res.msg)
              }
              this.editLoading = false
            })
            .catch(() => {
              this.editLoading = false
            })
        } else {
          this.editLoading = false
        }
      })
    },
    clearFormData(val) {
      if (val === 1) {
        if (this.formData.orderData && this.formData.orderData.length) {
          this.formData.FQueryDimension = '0'
        } else {
          this.formData.FQueryDimension = '1'
        }
      } else {
        if (Number(this.formData.FQueryDimension)) {
          this.formData.orderData = []
        }
      }
      this.getDataSummary()
    },
    getDataSummary() {
      if (this.formData.orderData && this.formData.orderData.length) {
        this.formData.FBeginOrderDate = this.formData.orderData[0]
        this.formData.FEndOrderDate = this.formData.orderData[1]
      } else {
        this.formData.FBeginOrderDate = this.formData.FEndOrderDate = ''
      }
      const jsonobj = JSON.parse(JSON.stringify(this.formData))
      jsonobj.FQueryDimension = Number(jsonobj.FQueryDimension)
      delete jsonobj.orderData
      delete jsonobj.FDepartNames
      const params = new URLSearchParams()
      params.append('jsonobj', JSON.stringify(jsonobj))
      request({
        url: '/mall/demand/userCenter/purchaseStatistics',
        method: 'post',
        params
      })
        .then(res => {
          if (res.result) {
            if (!res.data) {
              return this.$message.warning(res.msg)
            }
            this.showBox[0].money = res.data.FTotalAmount
            this.showBox[0].FOrderCount = res.data.FOrderCount
            this.showBox[0].FQuanty = res.data.FQuanty
            this.showBox[1].money = res.data.FDealAmout
            this.showBox[1].FOrderCount = res.data.FDealOrderCount
            this.showBox[1].FQuanty = res.data.FDealQuanty
            this.showBox[2].money = res.data.FReturnAmount
            this.showBox[2].FOrderCount = res.data.FReturnOrderCount
            this.showBox[2].FQuanty = res.data.FReturnQuanty
          } else {
            this.$message.error(res.msg)
          }
        })
    },
    cfmSearch(val) {
      //   const ids = []
      //   const names = []
      //   arr.forEach(t => {
      //     ids.push(t.FTreeCode)
      //     names.push(t.FDepartName)
      //   })
      this.defaultArr = val ? [val.fid] : ''
      this.formData.FTreeCode = val ? val.FTreeCode : ''
      this.formData.FDepartNames = val ? val.FName : ''
      this.selectDeparment(false)
      this.getDataSummary()
    },
    clearDepart() {
      this.formData.FTreeCode = this.formData.FDepartNames = ''
      this.defaultArr = []
      this.$refs.depart.clear()
      this.getDataSummary()
    },
    selectDeparment(val) {
      !val && this.$refs.depart.clear()
      this.searchVisible = val
    },
    initUser() {
      quest.userInfo().then(res => {
        if (res.result) {
          this.info = res.data
          this.StockCollectTotal = this.info.stockCollect || 0
          this.StoreCollectTotal = this.info.storeCollect || 0
          this.BrowseRecordsTotal = this.info.browseRecords || 0
        }
      })
    },
    edituser() {
      this.$refs.editUser.$emit(
        'dilong-editUser',
        true,
        this.info.fheadPortraitPath,
        this.info.fNickName
      )
    },
    dilongShow() {
      this.$refs.detailed.$emit('dilong-detailed', true)
    },
    save() {
      this.StockCollectSear()
      this.StoreCollectSear()
      this.BrowseRecordsSear()
    },
    // 查询商品收藏分页
    StockCollectSear(rest, fn) {
      if (rest === true) {
        this.StockCollect.pageNo = 1
        this.StockCollect.pageSize = 30
        this.StockCollect.total = 0
      }
      const params = `?pageNo=${this.StockCollect.pageNo}&pageSize=${this.StockCollect.pageSize
      }&jsonobj=${encodeURI(JSON.stringify(this.StockCollect.jsonobj))}`
      quest.stockCollect({
        params
      }).then(res => {
        console.log(res)
        if (res.result) {
          this.StockCollect.list = res.data.result.records
          this.StockCollect.pageNo = res.data.result.current
          this.StockCollect.pageSize = res.data.result.size
          this.StockCollect.total = res.data.result.total
        }
        if (fn) fn()
      })
    },
    // 关注店铺分页
    StoreCollectSear(type, fn) {
      if (type != undefined) {
        this.StoreCollect.pageNo = 1
        this.StoreCollect.pageSize = 30
        this.StoreCollect.total = 0
        this.StoreCollect.type = type
      } else {
        type = this.StoreCollect.type
      }
      const params = `?pageNo=${this.StoreCollect.pageNo}&pageSize=${this.StoreCollect.pageSize
      }&isShangxin=${type || 0}`

      quest.CollectSear({
        params
      }).then(res => {
        if (res.result) {
          this.StoreCollect.list = res.data.records
          this.StoreCollect.pageNo = res.data.pages
          this.StoreCollect.pageSize = res.data.size
          this.StoreCollect.total = res.data.total
        }
        if (fn) fn()
      })
    },

    // 加入购物车
    ShoppingCart(shop) {
      quest
        .ShoppingCart({
          params: `jsonobj=${encodeURI(
            JSON.stringify({
              shoppingCartList: shop
            })
          )}`
        })
        .then(res => {
          if (res.result) {
            this.$notify({
              customClass: 'shop-up',
              showClose: false,
              dangerouslyUseHTMLString: true,
              message: res.msg,
              duration: 1500,
              offset: 50
            })
            this.$parent.$parent.$refs.rightNav.comput.FSCQuanty++
          }
        })
    }
  }
}
</script>

<style lang="scss">
    .editPassword {
        padding: 0;
        margin-top: 8px !important;

        .popper__arrow::after {
            border-bottom-color: #EC212D !important;
        }

        .edit-title {
            height: 35px;
            line-height: 35px;
            padding-left: 12px;
            border-radius: 4px 4px 0 0;
            font-size: 16px;
            background: #EC212D;
            color: #fff;
        }

        .edit-content {
            width: 100%;
            margin-top: 17px;
            padding: 0 26px 0 17px;
            border-bottom: 1px solid #F2F3F6;
        }

        .edit-footer {
            padding-right: 14px;
            display: flex;
            justify-content: right;
            align-items: center;
            height: 46px;

            .edit-close {
                border: 1px solid #C4CBD7;
                color: #C4CBD7;
            }

            .edit-cfm {
                background: #EC212D;
                color: #fff;
            }
        }
    }

    .shop-up {
        width: 140px;
        padding: 5px 0;
        box-shadow: #eb1b24 0 0 6px;

        .el-notification__content {
            margin: 0;

            p {
                text-align: center;
                color: red;
            }
        }

        .el-notification__group {
            flex: 1;
        }
    }

    #user {
        height: 100%;
        overflow-y: auto;
        background: #ffffff;
        padding: 10px;
        margin-bottom: 20px;
        box-shadow: 0px 0px 10px 0px rgba(236, 33, 45, 0.1);

        #noShowPrice {
            display: inline-block;
            text-align: center;
            font-size: 14px;
            color: #ec2631;
            font-weight: 400;

            span {
                font-size: 12px;
            }
        }

        .user-record {
            .el-tabs__content {
                min-width: 1594px;
            }
            .el-tabs {
                overflow-y: auto;
            }
            .el-tabs__item {
                font-size: 16px;
            }
        }

        .user {
            margin-bottom: 0px;

            .header {
                width: 100%;
                height: 36px;
                background: #ec212d;
                font-size: 16px;
                font-weight: 400;
                color: #ffffff;
                padding-left: 10px;
                padding-top: 6px;
            }

            .body {
                padding-bottom: 0px;

                .user-information {
                    position: relative;

                    .purchase-data {
                        width: 62%;
                        padding-top: 50px;
                        position: absolute;
                        right: 0;

                        .title {
                            height: 34px;
                            border-bottom: 1px solid #EDEDF3;
                            font-size: 18px;
                            font-weight: 500;
                            color: #000000;
                        }

                        .search-condition {
                            display: flex;
                            margin-top: 15px;

                            .el-radio-group {
                                position: absolute;
                                right: 10px;
                            }

                            .el-input--suffix {
                                width: 30%;
                                margin-left: 32px;

                                .el-icon-menu {
                                    height: 40px;
                                    line-height: 40px;
                                    width: 20px;
                                }
                            }
                        }

                        // 滚动条
                        .over-box::-webkit-scrollbar {
                            /*滚动条整体样式*/
                            width: 10px;
                            /*高宽分别对应横竖滚动条的尺寸*/
                            height: 10px;
                        }

                        .over-box::-webkit-scrollbar-thumb {
                            /*滚动条里面小方块*/
                            border-radius: 10px;
                            -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
                            background: #E5E5E5;
                        }

                        .over-box::-webkit-scrollbar-track {
                            /*滚动条里面轨道*/
                            -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
                            border-radius: 10px;
                            background: #ffffff;
                        }

                        .over-box {
                            width: 100%;
                            overflow-x: auto;
                        }

                        .show-money {
                            display: flex;
                            margin-top: 21px;
                            margin-bottom: 5px;

                            .show-box {
                                position: relative;
                                min-width: 220px;
                                border: 1px solid #E7E8F3;
                                margin-right: 22px;
                                padding: 14px 0 0 16px;

                                .number-conetnt {
                                    display: flex;
                                    margin: 10px 0;
                                    position: relative;
                                    font-size: 14px;
                                    color: #84869D;

                                    div {
                                        width: 50%;
                                    }

                                    .show-number {
                                        font-size: 18px;
                                        color: #000000;
                                        font-weight: bold;
                                    }
                                }

                                .money-content {
                                    position: relative;
                                    margin-top: 10px;
                                    font-size: 24px;
                                    color: #EC212D;
                                    font-weight: 800;
                                }

                                .show-title {
                                    font-size: 16px;
                                    color: #5E6278;
                                }

                                .rt-svg {
                                    position: absolute;
                                    right: 11px;
                                    top: 11px;
                                    width: 38px;
                                    height: 38px;
                                }

                                .bg-svg {
                                    position: absolute;
                                    bottom: 4px;
                                    left: 4px;
                                    width: 65px;
                                    height: 72px;
                                }
                            }

                            .show-box:last-child {
                                margin-right: 0;
                            }
                        }
                    }

                    .information {
                        margin-left: 30px;
                        height: 190px;
                        display: flex;
                        align-content: center;
                        align-items: center;

                        .editBtn {
                            .el-button [class*=el-icon-]+span {
                                margin-left: 0;
                            }
                        }

                        .img {
                            img {
                                height: 72px;
                                width: 72px;
                                border-radius: 36px;
                                vertical-align: center;
                                object-fit: cover;
                            }
                        }

                        .content {
                            margin-left: 20px;
                            display: flex;
                            flex-direction: column;
                            justify-content: center;

                            .name {
                                margin-top: 12px;
                                font-size: 18px;
                                font-family: Microsoft YaHei;
                                font-weight: 400;
                                color: #333333;
                                margin-bottom: 16px;
                            }

                            .introduce {
                                //   display: flex;
                                font-size: 14px;
                                font-family: SimSun;
                                font-weight: 400;
                                color: #999999;
                                line-height: 25px;

                                .member {
                                    display: flex;

                                    .dj-icon {
                                        .hy-icon {
                                            height: 16px;
                                        }
                                    }
                                }
                            }
                        }
                    }

                    .wallet {
                        position: absolute;
                        left: 5px;
                        bottom: -10px;

                        .text {
                            font-size: 16px;
                            font-family: PingFang SC;
                            font-weight: 500;
                            color: #333333;
                            margin-left: 8px;
                        }
                    }
                }

                .user-wallet {
                    margin-bottom: 35px;
                    ;
                    display: flex;

                    .wallet {
                        position: relative;
                        width: 235px;
                        //   flex: 1;
                        display: flex;
                        flex-direction: column;
                        justify-content: center;
                        align-items: center;

                        .text {
                            font-size: 24px;
                            font-family: DIN;
                            font-weight: 600;
                            color: #333333;
                        }

                        .content {
                            font-size: 14px;
                            font-family: SimSun;
                            font-weight: 400;
                            color: #333333;
                            margin-top: 20px;
                        }

                        #cursor {
                            position: absolute;
                            bottom: -26px;
                            color: rgb(236, 33, 45);
                            cursor: pointer;
                        }
                    }
                }
            }

            .el-tabs__nav-wrap::after {
                background-color: rgba(255, 255, 255, 0) !important;
            }
        }
    }
</style>
